export default {
	ninzhidexinlande: '您值得信赖的旅行伙伴',
	zainalizhaodaonixiangyao: '在哪里找到你想要的廉价航班？',
	zhaodaoyitiaoshihenideluxian: '找到一条适合你的路线',
	zuijindedijiajipiao: '最近的低价机票',
	qingshuruhuoxuanzenidechengshi: '请输入或选择您的目的地',
	wodeyuding: '我的预订',
	kehuzhiyuan: '客户支援',
	suoyouhangban: '所有机场',
	denglu: '登录',
	yingwen: '英文',
	gangbi: '港币',
	baokuoshuifei: '包括税费',
	baokuotuoyunxingli: '包括托运行李',
	zhongzhuan: '中转',
	shijian: '次',
	yuyan: '语言',
	bizhong: '币种',
	jipiao: '机票',
	xuesheng: '学生',
	guyong: '雇佣',
	haiyuan: '海员',
	lvxingtuan: '旅行团',
	zuche: '租车服务',
	laihui: '往返',
	dancheng: '单程',
	duogemudidi: '多个目的地',
	you: '出发',
	dao: '到达',
	nianling: '年龄',
	sui: '岁',
	chufashijian: '出发时间',
	fanchengshijian: '返程时间',
	lvke: '旅客',
	cangdeng: '舱等',
	jingjicang: '经济舱',
	toudengcang: '头等舱',
	shangwucang: '商务舱',
	gaojijingjicang: '超级经济舱',
	souxun: '搜寻',
	remenyouhui: '热门优惠',
	remenjingdian: '热门景点',
	chengren: '成人',
	xiaotong: '儿童',
	yinger: '婴儿',
	souxunhangban: '搜寻航班',
	liaojiegengduo: '了解更多',
	guanyu: '关于',
	guanyuwomen: '关于我们',
	lianluowomen: '联络我们',
	fukuan: '付款',
	tiaokuanyuxize: '条款与细则',
	yinsizhengce: '私隐政策',
	fuwu: '服务',
	hangban: '航班',
	jiudian: '酒店',
	xueshengjipiao: '学生机票',
	guyongjipiao: '雇佣机票',
	haiyuanjipiao: '海员机票',
	changjianwenti: '常见问题',
	dingyueyoujian: '订阅电子邮件',
	nideyoujian: '你的电子邮件',
	qingshuru: '请输入',
	womenjieshou: '我们接受',
	paixushaixuan: '排序和筛选',
	remenhangbanyouhui: '热门航班优惠',
	chengshi: '城市',
	yaozuodeshiqing: '热门',
	huodong: '活动',
	ranggoupiaogengrongyi: 'Taro-Trip坚持“让购票更容易”的理念，为用户提供高质量的在线售票服务，为客户出行提供便利，为旅游业和经济发展做出贡献。',
	banquansuoyou: '版权所有',
	xiangtongchengshitishi: '出发城市与目的地城市不能是同一个',
};
